<!--
  ~ Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<fab-loading-spinner [hidden]="(!showSpinner)" color="primary"></fab-loading-spinner>
<div id="header-container">
  <h1 id="header-text">Create Industry Template</h1>
</div>

<div mat-dialog-content class="max-height flex-container flex-column">
  <div class="flex-row">
    <mat-button-toggle-group [(ngModel)]="marketFlag" class="flex max-width"
                             (ngModelChange)="getSubregionsOrMarketAreas()">
      <mat-button-toggle id="subregion-toggle" [value]="false" class="equal-flex-item">
        By Subregion
      </mat-button-toggle>
      <mat-button-toggle id="market-area-toggle" [value]="true" class="equal-flex-item">
        By Market Area
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>
  <div class="d-flex flex-column">
    <mat-form-field>
      <mat-label>Select Region</mat-label>
      <mat-select name="regions" id="regions" required [(ngModel)]="selectedRegion"
                  (ngModelChange)="getSubregionsOrMarketAreas()">
        <mat-option *ngFor="let region of regions" [value]="region.region">{{ region.region }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label *ngIf="marketFlag">Select Market Area</mat-label>
      <mat-label *ngIf="!marketFlag">Select Subregion</mat-label>

      <mat-select name="subregions" id="subregions" required [(ngModel)]="selectedSubregion"
                  (ngModelChange)="getPlanningMarkets()"
                  [disabled]="selectedRegion === null || selectedRegion === undefined">
        <mat-option *ngFor="let subregion of subregions" [value]="subregion">{{ subregion }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Select Planning Market(s)</mat-label>

      <fab-multiselect [(ngModel)]="planningMarkets.selectedOptions"
                       [options]="planningMarkets.options"
                       [disabled]="selectedSubregion === null || selectedSubregion === undefined"
                       required
                       id="planning-markets"></fab-multiselect>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Select Segment Level</mat-label>
      <mat-select name="segmentSchemeLevel" id="segment-level" required [(ngModel)]="selectedSegmentLevel"
                  [disabled]="validateOutput" (ngModelChange)="onTotalVehicleSelect()">
        <mat-option *ngFor="let level of segmentLevel" [value]="level">{{ level }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-checkbox [(ngModel)]="singleTab" id="single-tab"
                  [disabled]="selectedSegmentLevel==='Total Vehicle' || validateOutput">Output
      to Single Tab
    </mat-checkbox>
    <mat-checkbox [(ngModel)]="volumeOutput" id="volume" [disabled]="validateOutput">Volume Output</mat-checkbox>
    <mat-checkbox [(ngModel)]="mixOutput" id="mix" [disabled]="validateOutput">Mix Output</mat-checkbox>
    <mat-checkbox [(ngModel)]="validateOutput" id="validate" (ngModelChange)="onValidateCheck()">Validate Output
    </mat-checkbox>
  </div>
  <div class="d-flex flex-column">
    <div class="flex-container flex-row">
      <mat-form-field class="filter-options">
        <mat-label class="asterisk--before">Start Year</mat-label>
        <mat-select [(ngModel)]="startYear" id="startYear">
          <mat-option *ngFor="let year of scenarioYearRange" [value]="year">{{ year }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="filter-options">
        <mat-label class="asterisk--before">End Year</mat-label>
        <mat-select [(ngModel)]="endYear" id="endYear">
          <mat-option *ngFor="let year of scenarioYearRange" [value]="year">{{ year }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="d-flex flex-row gap-8">
      <button mat-stroked-button color="primary" class="d-flex equal-flex-item" id="cancel-button"
              (click)="this.dialogRef.close()">Cancel
      </button>
      <button mat-flat-button color="primary" class="d-flex equal-flex-item" id="submit-button"
              [disabled]="isButtonDisabled()"
              (click)="queryIndustry()">Confirm
      </button>
    </div>

  </div>
</div>
